import { useRouter } from 'next/router';

import {
  sortToViewerTopListItems,
  TeamUserListItem,
} from 'presentations/api/schema/team_user';
import { UserScheduleCount, ViewerItem } from 'presentations/api/schema/user';
import {
  DashboardPortalContext,
  setProjects,
} from 'presentations/reducers/DashboardPortal';
import {
  apiPath,
  dashboardPath,
  dashboardStatsPath,
  dashboardFormListPath,
  scheduledEventListPath,
} from 'presentations/routes/path';
import { useRequest } from 'presentations/views/hooks/request';
import { useContext, useEffect } from 'react';

interface Props {
  viewer: ViewerItem;
  userId: string | null;
  projectId?: string | null;
}

export const useDashboardHomeNavigation = (props: Props) => {
  const portalContext = useContext(DashboardPortalContext);
  // Start: localStorageからのmigration用にしばらくは必要
  const projectsRequest = useRequest(
    props.viewer
      ? apiPath(
          `/v1/teams/${props.viewer.team!.uid}/users/${
            props.viewer.uid
          }/projects`,
        )
      : null,
  );
  const teamUsersRequest = useRequest(
    apiPath(`/v1/teams/${props.viewer.team!.uid}/users`, {
      page: 1,
      perPage: 100,
    }),
  );
  const teamUsers: TeamUserListItem[] = sortToViewerTopListItems(
    props.viewer,
    teamUsersRequest.data || [],
  );
  // End: localStorageからのmigration用にしばらくは必要

  useEffect(() => {
    if (projectsRequest.isLoading) return;
    portalContext.dispatch(setProjects(projectsRequest.data));
  }, [projectsRequest.data]);

  const scheduleCountRequest = useRequest(
    props.projectId
      ? apiPath(
          `/v1/teams/${props.viewer.team!.uid}/schedules_count?projectUid=${
            props.projectId
          }`,
        )
      : apiPath(
          `/v1/teams/${props.viewer.team!.uid}/schedules_count?userId=${
            props.userId
          }`,
        ),
  );
  const schedulesCount: UserScheduleCount | null = scheduleCountRequest.data;

  const tasksCountRequest = useRequest(
    props.userId
      ? apiPath(
          `/v1/teams/${props.viewer.team!.uid}/users/${
            props.userId
          }/tasks_count`,
        )
      : null,
  );
  const tasksCount: number = tasksCountRequest.data;

  const router = useRouter();

  const onChangeTab = (event: React.ChangeEvent<{}>, index: number) => {
    const userId = props.viewer.uid === props.userId ? null : props.userId;
    const url = [
      dashboardPath({ user: userId, project: props.projectId }),
      scheduledEventListPath({
        userId,
        projectId: props.projectId,
        filters: { ...router.query },
      }),
      dashboardFormListPath({ userId, projectId: props.projectId }),
      // dashboardTodayPath(userId),
      dashboardStatsPath({ userId, projectId: props.projectId }),
    ][index];
    if (url) router.push(url);
  };

  return {
    state: {
      teamUsers,
      tasksCount: tasksCount,
      schedulesCount: schedulesCount
        ? schedulesCount.incoming + schedulesCount.pending
        : 0,
    },
    actions: {
      onChangeTab,
    },
  };
};
